<template>
    <v-dialog v-model="showDialog" width="600px">
        <v-card>
            <v-card-title class="justify-center">View, add & delete codes</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4"><b>{{ akcd.akcd_oms }}</b></v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table 
                    :items="akcd.akcc" 
                    :items-per-page="10" 
                    :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                    :headers="headers">
                    <!-- :search="search">  -->
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.akcc_regel }}</td>
                            <td><btn_component type="icon" icon="mdi-trash-can-outline" color="red" tooltip="Delete code" size="x-small" :data="props.item" @actionClick="deleteCode"/></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <btn_component type="text" text="Add code" color="primary" tooltip="Add a new code" size="x-small" :data="true" @actionClick="addCode"/>
                <v-spacer></v-spacer>
                <btn_component type="text" text="Close" color="primary" tooltip="close" size="x-small" data="" @actionClick="closeDialog"/>
            </v-card-actions>
        </v-card>
        <akcd_addAkcc ref="akcd_addAkcc" @addedAkcc="addedAkcc"/>
        <akcd_rmAkcc ref="akcd_rmAkcc" @deletedAkcc="deletedAkcc"/>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import akcd_addAkcc from "@/components/syst/ref/akcd/akcd_addAkcc.vue";
    import akcd_rmAkcc from "@/components/syst/ref/akcd/akcd_rmAkcc.vue";
    
    export default {
        components: {
            btn_component,
            akcd_addAkcc,
            akcd_rmAkcc,
        },    
        data() {
            return {
                showDialog: false,
                akcd: {
                    akcd_oms: "",
                },
                codes: [],
                headers: [
                    { text: "Code", value: "akcc_oms", width: "90%" },
                    { text: "Delete", value: "", width: "10%" },
                ],
            }
        },  
        methods: {  
            openDialog(akcd) {
                console.log(akcd)
                this.akcd = akcd;
                this.showDialog = true;
            },
            addCode() {
                this.$refs.akcd_addAkcc.openDialog(this.akcd);
            },
            addedAkcc(akcc) {
                this.akcd.akcc.push(akcc);
            },
            deleteCode(akcc) {
                // console.log(akcc)
                this.$refs.akcd_rmAkcc.openDialog(akcc);
            },
            deletedAkcc(akcc_encrid) {
                let tmp = [];
                for (let iIndex=0;iIndex< this.akcd.akcc.length;iIndex++) {
                    
                    if (this.akcd.akcc[iIndex].akcc_encrid !== akcc_encrid) {
                        tmp.push(this.akcd.akcc[iIndex]);
                    }
                }
                this.akcd.akcc = tmp;
            },
            closeDialog() {
                this.$emit("refreshList");
                this.showDialog = false;
            },
        }
    }
</script>

<style scoped> 

</style>